export let SignatureFormat = /*#__PURE__*/function (SignatureFormat) {
  SignatureFormat["TEXT"] = "text/plain";
  SignatureFormat["POINTS"] = "points/json";
  return SignatureFormat;
}({});
//# sourceMappingURL=signature-types.js.map